import React, { Component } from 'react';
import MusicGrid from '../../components/MusicGrid';
import RibbonsUtil from '../../utils/RibbonsUtil';
import Spinner from './../../components/Spinner';
import Placeholder from '../../containers/Placeholder';
import CountriesFilter from '../../containers/Radios/countriesFilter';
import CitiesFilter from '../../containers/Radios/citiesFilter';
import { connect } from 'react-redux';
import RadiosDetailAdapter from './RadiosDetailAdapter';
import logger from 'src/utils/logger/logger';

class Radios extends Component {
    constructor(props) {
        super(props);
        this.getRadios = this.getRadios.bind(this);
        this.fetchMoreRadios = this.fetchMoreRadios.bind(this);
        this.onSelectFilter = this.onSelectFilter.bind(this);
        this.state = {
            user: props.user.musicUser,
            totalRadios: [],
            isFetching: false,
            radios: [],
            start: 0,
            size: 30,
            showPlaceholder: false,
            countrySelected: '',
            citySelected: '',
            countryCode: ''
        };
    }
    componentDidMount() {
        this.getRadios();
    }

    getRadios(countryName = '', stateId = '', cityId = '') {
        const { user, size } = this.state;
        let { radios } = this.state;
        let totalRadiosTmp = radios;
        const { setIsFetching, tab } = this.props;
        setIsFetching(true);
        const service =
            tab === 1 || tab === 2 ? 'topRadios' : tab === 3 ? 'genreRadios' : 'artistRadios';
        const musicRb = new RibbonsUtil();
        const data = tab === 1 || tab === 2 ? { stateId, cityId, country_radio: countryName } : {};
        musicRb
            .getRadiosApi(service, user, data)
            .then(resp => {
                const { components } = resp.response;
                radios = components.items;
                if (components.items.length === 1) {
                    if (tab === 1) {
                        radios = RadiosDetailAdapter(components.items[0].topsRadios.slice(0, size));
                        totalRadiosTmp = RadiosDetailAdapter(components.items[0].topsRadios);
                    } else {
                        radios = RadiosDetailAdapter(components.items[0].newsRadios.slice(0, size));
                        totalRadiosTmp = RadiosDetailAdapter(components.items[0].newsRadios);
                    }
                }
                this.setState({
                    radios,
                    totalRadios: totalRadiosTmp,
                    start: size,
                    showPlaceholder: !(radios.length > 0)
                });
                setIsFetching(false);
            })
            .catch(err => {
                logger.error('Fail ribbons: ' + err);
            });
    }

    fetchMoreRadios() {
        let { radios } = this.state;
        const { totalRadios, start, size } = this.state;
        const { setIsFetching } = this.props;
        this.setState({ isFetching: true });
        setIsFetching(true);

        radios = radios.concat(totalRadios.slice(start, start + size));

        this.setState({
            radios,
            start: start + size,
            isFetching: false
        });
        setIsFetching(false);
    }

    onSelectFilter(filter) {
        const countryCode = filter.code || filter.country;
        const countryName = filter.nameCountry || filter.name;
        const state = filter.state || '';
        const city = filter.slug || '';
        const cityName = filter.nameCity || '';

        this.setState(
            {
                start: 0,
                size: 30,
                countryCode: countryCode,
                countrySelected: countryName,
                citySelected: cityName,
                radios: []
            },
            () => {
                this.getRadios(countryName, state, city);
            }
        );
    }

    render() {
        const {
            isFetching,
            showPlaceholder,
            radios,
            countryCode,
            countrySelected,
            citySelected
        } = this.state;
        const {
            onFocusCardHandler,
            service,
            setMetricsEvent,
            stationTitle,
            tab,
            user
        } = this.props;

        return (
            <div>
                {isFetching && <Spinner />}
                {service && (
                    <div className="radio-filter">
                        <CountriesFilter
                            title={countrySelected}
                            user={user.musicUser}
                            countryCode={countryCode}
                            onSelectFilter={this.onSelectFilter}
                        />
                        <CitiesFilter
                            title={citySelected}
                            user={user.musicUser}
                            countryCode={countryCode}
                            onSelectFilter={this.onSelectFilter}
                        />
                    </div>
                )}
                <MusicGrid
                    items={radios}
                    onFocusHandler={onFocusCardHandler}
                    gridType="radio"
                    type={tab === 4 ? 'circle' : 'square'}
                    service={service}
                    getMore={this.fetchMoreRadios}
                    setMetricsEvent={setMetricsEvent}
                    stationTitle={stationTitle}
                />
                {showPlaceholder && <Placeholder type={'radiosSection'} />}
            </div>
        );
    }
}

export default connect(null, null, null, { withRef: true })(Radios);



// WEBPACK FOOTER //
// ./src/components/Radios/index.jsx